import { ToastContainer } from 'react-toastify';
import AppRoutes from './Routes/AppRoutes';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        closeButton={true}   
      />
    </div>
  );
}

export default App;
